import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=e958aec2&scoped=true&lang=pug&"
import script from "./ButtonSubmit.vue?vue&type=script&lang=ts&"
export * from "./ButtonSubmit.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSubmit.vue?vue&type=style&index=0&id=e958aec2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e958aec2",
  null
  
)

export default component.exports